import { Infer, instance, object } from "superstruct";

export const ReviewsDrawerWidgetConfigSchema = object({
    target: instance(HTMLElement),
});

export const ReviewsDrawerWidgetConfigToken = Symbol(
    "ReviewsDrawerWidgetConfigToken"
);

export type ReviewsDrawerWidgetConfigInterface = Infer<
    typeof ReviewsDrawerWidgetConfigSchema
>;
